import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteAdministrationRotationScreenService {
	async run(params: any): Promise<void> {
		await removeWithQueryParams(`${services.rotationScreen}/deleterotationScreen`, params);
	}
}

